/**
 * `live` — multi-provider live classes (Design B, F2-B).
 *
 * Adding a provider = implementing `MeetingProvider` + `register()`. The rest
 * of the app (live screen, settings, catalog) does NOT change.
 */
export * from "./registry";
// F3-G: client mirror of the join window + embed options builder.
export * from "./window";
export * from "./embed";
export { jitsiProvider } from "./providers/jitsi";
export { zoomProvider } from "./providers/zoom";
export { meetProvider } from "./providers/meet";
export { customLinkProvider } from "./providers/custom_link";
export { makeExternalProvider } from "./providers/external";

import type { FeatureManifest } from "../academy/country/packs";
import { customLinkProvider } from "./providers/custom_link";
import { jitsiProvider } from "./providers/jitsi";
import { meetProvider } from "./providers/meet";
import { zoomProvider } from "./providers/zoom";
import {
  MeetingProviderRegistry,
  meetingProviderToFeatureManifest,
  type MeetingProvider,
} from "./registry";

/** The live class providers Space ships with (v1). */
export const baseMeetingProviders: readonly MeetingProvider[] = [
  jitsiProvider,
  zoomProvider,
  meetProvider,
  customLinkProvider,
];

/** Registry loaded with the base providers. Starting point for the app. */
export function defaultMeetingProviderRegistry(): MeetingProviderRegistry {
  return new MeetingProviderRegistry().registerAll(baseMeetingProviders);
}

/**
 * Catalog-ready manifests of the live providers (keys `media.provider.<id>`).
 * Same shape as `countryPackManifests()` — F2-D consumes them in `gen:features`.
 */
export function mediaProviderManifests(): FeatureManifest[] {
  return baseMeetingProviders.map((p) => meetingProviderToFeatureManifest(p.manifest));
}
